import React, { useEffect, useRef } from 'react';
import ExpertiseCard from './ExpertiseCard';

interface ScrollingBarProps {
  frameworkNames: string[];
}

const ScrollingBar: React.FC<ScrollingBarProps> = ({ frameworkNames }) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    let scrollAmount = 0;
    const scrollStep = 1; // Adjust this value for scroll speed
    const scrollInterval = 20; // Adjust this value for scroll interval

    const scrollContent = () => {
      scrollAmount += scrollStep;
      scrollContainer.scrollLeft += scrollStep;

      if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
        scrollContainer.scrollLeft = 0;
      }
    };

    const interval = setInterval(scrollContent, scrollInterval);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative overflow-hidden">
      <div
        className="flex overflow-x-scroll scrollbar-hide gap-4"
        ref={scrollContainerRef}
      >
        {frameworkNames.concat(frameworkNames).map((name, index) => (
          <ExpertiseCard key={index} framworkName={name} />
        ))}
      </div>
    </div>
  );
};

export default ScrollingBar;
